module.exports = __webpack_public_path__ + "img/home-snacks.632dcb65.png";